import PropTypes from 'prop-types'

export const UserType = PropTypes.shape({
  created: PropTypes.number,
  email: PropTypes.string,
  id: PropTypes.string,
  role: PropTypes.oneOf(['superadmin', 'admin']),
})
